import API from ".";

export const worshopSelection = (workshopId,variantId, carModelId, carBrandId) => API.get(`v2/api/workshops/${workshopId}/jobs?page=1&variantId=${variantId}&carModelId=${carModelId}&sortingCol=Distance&workshopId=${workshopId}&lat=1&lng=1&size=40&brandId=${carBrandId}`);